import { BreakpointObserver, Breakpoints, BreakpointState } from '@angular/cdk/layout';
import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import * as _ from 'lodash';import { PrimeNGConfig } from 'primeng/api';
;
import { AuthService } from '../../services/auth.service';
import { ThemeSwitcherService } from '../../services/theme-switcher.service';
import { VersionService } from '../../services/version.service';
import { ROLES } from '../../utils/constants';



@Component({
  selector: 'mapfre-auditlib-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  @Input()
  title;

  @Input()
  items;


  canShowNewPAI;
  canShowNewWork;

  showSubheader: boolean = false;
  displayModal;
  displayLanguageModal;

  showFirstLettersUser;

  userFirstLetters;
  versionTooltip;

  currentLang;
  availableLangs;

  isTablet;

  constructor(public translateService: TranslateService,
    public themeSwitcherService: ThemeSwitcherService,
    private authService: AuthService,
    private versionService: VersionService,
    private router: Router,
    public breakpointObserver: BreakpointObserver,
    private primeNGConfig: PrimeNGConfig) {
      this.availableLangs = [
        {code:"en",label:"Ingles"},
        {code:"es",label:"Español"},
        {code:"pt",label:"Portugues"},
        {code:"pt_br",label:"Portugues Brasileño"},
        {code:"tr",label:"Turco"}
      ]
    }

  ngOnInit() {
    this.canShowNewPAI = this.authService.userHasAtleastOneRole([ROLES.DIRECTOR, ROLES.JEFE_DE_AREA]);
    this.canShowNewWork = this.authService.userHasAtleastOneRole([ROLES.DIRECTOR, ROLES.JEFE_DE_AREA, ROLES.AUDITOR]);
    this.userFirstLetters = this.authService.getUserFirstLetters();
    this.versionService.getAllVersions().subscribe(res => {
      this.versionTooltip = `
      <div class="version">
        <b>front: </b> ${_.get(res, 'front')}
        <b>aws: </b> ${_.get(res, 'aws')}
        <b>back: </b> ${_.get(res, 'back')}
      </div>
      `
    })
    this.isTablet = _.get(this.themeSwitcherService,'isTablet');
    this.themeSwitcherService.observer.subscribe(res => {
      this.isTablet = _.get(res,'isTablet');
    })
    this.currentLang = this.translateService.currentLang;
    this.translateService.onLangChange.subscribe(res => {
      this.currentLang = res.lang;
    })
  }

  goRoute(route) {
    this.router.navigate([route]);
    this.showSubheader = false;
  }

  showProfile() {
    let nuuma = this.authService.getNuuma();
    this.router.navigate(["/pages/user/profile/", nuuma]);
  }
  onLogoutClick() {
    this.authService.logout();
  }

  changeLanguage(lang) {
    this.translateService.resetLang(lang) // incidencia 242 Estado resuelta, se ha añadido un reset para que recarge el idioma
    this.translateService.use(lang);
    this.translateService.get('primeng').subscribe(res => this.primeNGConfig.setTranslation(res));
  }



}
